import { Controller } from 'react-hook-form';

import { ClassName, I18nText, IsDisabled } from '../../../../types';
import { RoleID } from '../../rolesTypes';

import { RolesMultiSelectFieldRequiredProps } from './RolesMultiSelectField.types';

import { RolesMultiSelectFieldControl } from './components/RolesMultiSelectFieldControl';

interface RolesMultiSelectFieldProps {
  financeRoles?: boolean;
  i18nPlaceholder?: I18nText;
  i18nLabel?: I18nText;
  disabled?: IsDisabled;
  inputWrapperClassName?: ClassName;
  labelClassName?: ClassName;
}

function RolesMultiSelectField<FormDataType>({
  financeRoles,
  control,
  i18nPlaceholder,
  i18nLabel,
  disabled,
  inputWrapperClassName,
  labelClassName,
  name
}: RolesMultiSelectFieldProps &
  RolesMultiSelectFieldRequiredProps<FormDataType>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => (
        <RolesMultiSelectFieldControl
          financeRoles={financeRoles}
          classNamePrefix="av"
          closeMenuOnSelect={false}
          disabled={disabled}
          error={error?.message}
          i18nPlaceholder={i18nPlaceholder}
          i18nLabel={i18nLabel}
          inputWrapperClassName={inputWrapperClassName}
          labelClassName={labelClassName}
          menuPosition="fixed"
          onChange={onChange}
          value={value as RoleID[]}
          name={name}
        />
      )}
    />
  );
}

export default RolesMultiSelectField;
